<template>
  <div>
    <section id="sub_visual" class="pic04">
      <p>이트너스 비딩</p>
      <span>About etnersbidding Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con04 clear">
        <h6>투명한 경쟁입찰,<br/>
          최고가 유휴자산 매각!</h6>
        <span class="ctext1">이트너스  비딩은  매각관련 전체 프로세스를 온라인 시스템을  통해<br/>
      일괄 처리 가능한 국내 최고 기업자산매칭 솔루션입니다. </span>
        <p class="ctext2 w75p"><span>Why etners bidding?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_13.png" width="104" height="104" alt=""/></p>
              <h6>소싱부터 회계처리까지 한번에</h6>
              <p>업체 소싱부터 회계처리까지 전체 매각 프로세스에 대해 이트너스 비딩 담당자가 관리/감독하여 고객의 자산관리의 편의를 제공합니다.</p>
            <li>
              <p><img src="../../assets/images/c_im_14.png" width="104" height="104" alt=""/></p>
              <h6>경쟁입찰을 통한 최고가 유휴자산매각</h6>
              <p>경매방식의 중복투찰로 경쟁입찰이 진행되는 입찰 시스템을 통해 투찰 금액 중 퇴고가에 낙찰 받으실 수 있습니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_15.png" width="104" height="104" alt=""/></p>
              <h6>엄격한 관리로 부정행위 차단</h6>
              <p>참여업체명 비공개로 담합방지, 실사시간을 다르게 하는 등의 프로세스로 유형자산 매각, 회사 자산매각을 공정하게 수행합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_16.png" width="104" height="104" alt=""/></p>
              <h6>다양한 유형자산에 대한 매각 진행</h6>
              <p>시설장비, 차량, 비품, 계측장비, PC 및 가전 등 다양한  매각 경험으로  모든 유형자산에 대한 매각이 가능합니다. </p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.etnersbidding.com',
        solNm :'이트너스비딩',
        solCd : '2003'
      }
    }
  }
</script>
